export const isEmpty = (str: string | undefined | null) => !str || !str.trim();